<template>
  <ui-component-modal
    modalTitle="Edit text"
    modalSize="large"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="saveOptionText"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <div class="columns is-multiline">
        <div
          v-for="(text, index) in mOption.Texts"
          :key="'column' + index"
          class="column is-half"
        >
          <p>{{ $t('LanguageLabels.Language' + text.LanguageId) }}</p>
          <div class="field">
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Space name"
                v-model="text.Name"
              />
            </div>
          </div>
          <div class="field">
            <div class="control">
              <ui-text-editor
                :id="'editor' + index"
                v-model="text.Description"
              ></ui-text-editor>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import optionProvider from '@/providers/option'

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },

    locationId: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      mOption: null,
    }
  },

  computed: {
    ...mapState('optionStore', ['option']),
  },

  created() {
    this.mOption = JSON.parse(JSON.stringify(this.option))
  },

  methods: {
    ...mapMutations('optionStore', ['setOption']),

    saveOptionText() {
      let self = this

      if (!self.isSaving) {
        self.isSaving = true

        optionProvider.methods
          .saveLocationOptionTexts(
            self.mOption.Id,
            self.locationId,
            self.mOption.Texts
          )
          .then((response) => {
            self.isSavingSuccess = true

            self.setOption(response.data)

            let t = setTimeout(() => {
              self.onClickCancel()
              clearTimeout(t)
            }, 1500)
          })
          .catch((e) => {
            self.isSavingError = true
          })
          .finally(() => {
            self.isSaving = false
          })
      }
    },
  },
}
</script>
